<template>
    <div>
        <messaging
            :display="message.display"
            :top="true"
            :text="message.text"
            :timeout="message.timeout"
            v-on:closed="message.display = false"
        />
        <v-dialog
            v-model="$store.getters.overlays.contactUs"
            :fullscreen="$store.getters.window.width <= 800"
            width="1000"
        >
            <v-card :class="$style.contactUsCard" v-if="requestSubmitted === false">
                <v-icon
                    @click="
                        $refs.userFormContactUs.reset();
                        $emit('close');
                    "
                    color="black"
                    :class="$style.contactUsCloseBtn"
                    >fa-times-circle</v-icon
                >
                <h3 :class="$style.contactUsTitle">
                    <str index="contact_us > title" />
                </h3>
                <p :class="$style.contactUsSubTitle">
                    <str index="contact_us > subTitle" />
                </p>
                <v-form ref="userFormContactUs" v-model="contactUsValidation">
                    <v-container style="margin-top: 2.5%; width: 85%;" fluid>
                        <v-layout row wrap>
                            <v-flex xs8 :sm5="lang == 'en'" :sm7="lang == 'fr'">
                                <div :class="$style.subjectInputWrapper">
                                    <p>
                                        <str index="contact_us > form subject" />
                                    </p>
                                    <v-select
                                        :class="['contactUsInput']"
                                        :items="subject_list"
                                        outlined
                                        dense
                                        :rules="formRules().validSubject"
                                        v-model="subject_data.subject"
                                        return-object
                                    >
                                        <template v-slot:message="{ message }">
                                            <str :index="message" />
                                        </template>
                                        <template slot="selection" slot-scope="data">
                                            <!-- HTML that describe how select should render selected items -->
                                            <str :class="$style.subjectInput" :index="data.item.text" />
                                        </template>

                                        <v-list-item-content slot="item" slot-scope="data">
                                            <!-- HTML that describe how select should render items when the select is open -->
                                            <v-list-item-title>
                                                <str :index="data.item.text" />
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-select>
                                </div>
                            </v-flex>

                            <v-flex xs8 sm9>
                                <div
                                    :class="$style.programInputWrapper"
                                    v-if="subject_data.subject && subject_data.subject.value === 'program'"
                                >
                                    <p>
                                        <str index="contact_us > form program" />
                                    </p>
                                    <v-select
                                        :class="['contactUsInput']"
                                        :items="subject_program"
                                        outlined
                                        dense
                                        :rules="formRules().validProgram"
                                        v-model="subject_data.program"
                                    >
                                        <template v-slot:message="{ message }">
                                            <str :index="message" />
                                        </template>
                                    </v-select>
                                </div>
                            </v-flex>

                            <v-flex xs8 sm4>
                                <div :class="$style.titleInputWrapper">
                                    <p>
                                        <str index="contact_us > form title" />
                                    </p>
                                    <v-select
                                        :class="['contactUsInput']"
                                        :items="subject_title"
                                        outlined
                                        dense
                                        :rules="formRules().validTitle"
                                        v-model="subject_data.title"
                                    >
                                        <template v-slot:message="{ message }">
                                            <str :index="message" />
                                        </template>
                                        <template
                                            slot="selection"
                                            slot-scope="data"
                                            dense
                                            :class="['contactUsInput']"
                                        >
                                            <!-- HTML that describe how select should render selected items -->
                                            <str :index="data.item.text" />
                                        </template>

                                        <v-list-item-content slot="item" slot-scope="data">
                                            <!-- HTML that describe how select should render items when the select is open -->
                                            <v-list-item-title>
                                                <str :index="data.item.text" />
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-select>
                                </div>
                            </v-flex>

                            <template v-if="user === false">
                                <v-flex xs6 sm4>
                                    <div :class="$style.firstnameInputWrapper">
                                        <p>
                                            <str index="contact_us > form firstname" />
                                        </p>
                                        <v-text-field
                                            :class="['contactUsInput']"
                                            outlined
                                            dense
                                            v-model="subject_data.firstname"
                                            validate-on-blur
                                            :rules="formRules().validFirstName"
                                        >
                                            <template v-slot:message="{ message }">
                                                <str :index="message" />
                                            </template>
                                        </v-text-field>
                                    </div>
                                </v-flex>

                                <v-flex xs6 sm4>
                                    <div :class="$style.lastnameInputWrapper">
                                        <p>
                                            <str index="contact_us > form lastname" />
                                        </p>
                                        <v-text-field
                                            :class="['contactUsInput']"
                                            outlined
                                            dense
                                            v-model="subject_data.lastname"
                                            validate-on-blur
                                            :rules="formRules().validLastName"
                                        >
                                            <template v-slot:message="{ message }">
                                                <str :index="message" />
                                            </template>
                                        </v-text-field>
                                    </div>
                                </v-flex>
                            </template>

                            <v-flex xs8>
                                <div :class="$style.emailInputWrapper">
                                    <p>
                                        <str index="contact_us > form email" />
                                    </p>
                                    <v-text-field
                                        :class="['contactUsInput']"
                                        outlined
                                        dense
                                        v-model="subject_data.email"
                                        validate-on-blur
                                        :rules="formRules().validEmail"
                                    >
                                        <template v-slot:message="{ message }">
                                            <str :index="message" />
                                        </template>
                                    </v-text-field>
                                </div>
                            </v-flex>

                            <v-flex xs12>
                                <div :class="$style.messageInputWrapper">
                                    <p>
                                        <str index="contact_us > form message" />
                                    </p>
                                    <div>
                                        <v-textarea
                                            v-model="subject_data.message"
                                            outlined
                                            required
                                            :rules="formRules().validMessage"
                                        >
                                            <template v-slot:message="{ message }">
                                                <str :index="message" />
                                            </template>
                                        </v-textarea>
                                    </div>
                                </div>
                            </v-flex>

                            <v-flex xs12 :class="$style.submitBtnWrapper" pb-5>
                                <v-btn color="#409cea" dark @click="validateContactUs()">
                                    <str index="button > submit" />
                                </v-btn>

                                <p>
                                    <str index="contact_us > support" />
                                </p>
                            </v-flex>
                        </v-layout>
                    </v-container>
                    <br />
                </v-form>
            </v-card>

            <v-card :class="$style.contactUsCardResponse" v-if="requestSubmitted === true">
                <v-icon
                    @click="
                        requestSubmitted = false;
                        $emit('close');
                    "
                    color="black"
                    :class="$style.contactUsCloseBtn"
                >
                    fa-times-circle</v-icon
                >
                <v-card-title class="justify-center">
                    <h3 :class="$style.contactUsTitle">
                        <str index="contact_us > response title" />
                    </h3>
                </v-card-title>
                <v-card-text>
                    <p :class="$style.contactUsSubTitle_">
                        <str index="contact_us > response subtitle sent_successfully" />
                    </p>
                    <p :class="$style.contactUsSubTitle_">
                        <str index="contact_us > response subtitle feedback" />
                    </p>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import _cloneDeep from "lodash/cloneDeep";
export default {
    name: "ContactUs",
    created: function() {
        this.init();
    },
    data: function() {
        return {
            message: {
                display: false,
                text: null,
                timeout: null,
            },
            subject_data: {
                subject: null,
                title: null,
                firstname: null,
                lastname: null,
                program: null,
                email: null,
                message: null,
            },
            contactUsValidation: false,
            requestSubmitted: false,
        };
    },
    methods: {
        init: function() {
            if (this.user) {
                this.subject_data.title = this.user.title;
                this.subject_data.firstname = this.user.firstname;
                this.subject_data.lastname = this.user.lastname;
                this.subject_data.email = this.user.email;
                this.subject_data.program = null;
                this.subject_data.message = null;
            } else {
                this.subject_data = {
                    subject: null,
                    title: null,
                    firstname: null,
                    lastname: null,
                    program: null,
                    email: null,
                    message: null,
                };
            }
        },
        validateContactUs: function() {
            let self = this;
            let cloneSubjectData = _cloneDeep(this.subject_data);
            let data = {
                subject: cloneSubjectData.subject.value,
            };
            cloneSubjectData.subject = this.labels(cloneSubjectData.subject.text);
            data["message"] = JSON.stringify(cloneSubjectData);
            if (this.$refs.userFormContactUs.validate()) {
                this.$sendRequest({
                    action: "contactUs",
                    call: "postContactUs",
                    data: JSON.stringify(data),
                    language: this.lang,
                }).then(
                    function(response) {
                        if (response.status == 200) {
                            if (response.data.contactUs.postContactUs.error === undefined) {
                                this.$refs.userFormContactUs.reset();
                                setTimeout(function() {
                                    self.requestSubmitted = true;
                                    self.init();
                                }, 400);
                            } else {
                                this.message.text = this.labels("message > system_failure generic");
                                this.message.display = true;
                            }
                        }
                    }.bind(this)
                );
            }
        },
    },

    computed: {
        subject_list: function() {
            return [
                {
                    text: "contact_us > subject content_issue",
                    value: "inappropraite",
                },
                {
                    text: "contact_us > subject general_feedback",
                    value: "feedback",
                },
                {
                    text: "contact_us > subject platform_issue",
                    value: "platform",
                },
                {
                    text: "contact_us > subject program_issue",
                    value: "program",
                },
                {
                    text: "contact_us > subject other",
                    value: "other",
                },
            ];
        },
        subject_title: function() {
            if (this.$language() == "en") {
                return [
                    {
                        text: "contact_us > subject_title mr",
                        value: "mr",
                    },
                    {
                        text: "contact_us > subject_title mrs",
                        value: "mrs",
                    },
                    {
                        text: "contact_us > subject_title miss",
                        value: "miss",
                    },
                    {
                        text: "contact_us > subject_title ms",
                        value: "ms",
                    },
                    {
                        text: "contact_us > subject_title dr",
                        value: "dr",
                    },
                ];
            } else {
                return [
                    {
                        text: "contact_us > subject_title mr",
                        value: "mr",
                    },
                    {
                        text: "contact_us > subject_title mrs",
                        value: "mrs",
                    },
                    {
                        text: "contact_us > subject_title miss",
                        value: "miss",
                    },
                    {
                        text: "contact_us > subject_title ms",
                        value: "ms",
                    },
                    {
                        text: "contact_us > subject_title dr",
                        value: "dr",
                    },
                    {
                        text: "contact_us > subject_title dre",
                        value: "dre",
                    },
                ];
            }
        },
        subject_program: function() {
            var allPrograms = this.$store.getters.programs;
            var subject_programs = [];
            for (var i = 0; i < allPrograms.length; i++) {
                var program = allPrograms[i];
                if (program.state === "live") {
                    var objectProgram = {
                        text: program["name"][this.lang],
                        value: program["name"][this.lang] + "(" + program["id"] + ")",
                    };
                    subject_programs.push(objectProgram);
                }
            }

            return subject_programs;
        },
        user: function() {
            return this.$store.getters.user;
        },
        lang: function() {
            return this.$store.getters.language;
        },
    },
    watch: {
        user: {
            handler: function(after) {
                if (after) {
                    this.subject_data.email = after.email;
                    this.subject_data.title = after.title;
                    this.subject_data.firstname = after.firstname;
                    this.subject_data.lastname = after.lastname;
                } else {
                    this.subject_data.email = null;
                    this.subject_data.title = null;
                    this.subject_data.firstname = null;
                    this.subject_data.lastname = null;
                    if (this.$refs.userFormContactUs) {
                        this.$refs.userFormContactUs.reset();
                    }
                }
            },
            deep: true,
        },
    },
};
</script>

<style module>
.contactUsCard,
.contactUsCardResponse {
    position: relative;
    border-radius: 20px;
    background-image: linear-gradient(180deg, rgba(255, 255, 255, 0.8) 0%, rgba(255, 255, 255, 0.5) 100%),
        url("./contact_us.png");
    background-repeat: no-repeat;
    background-position: 100% 100%;
}

.contactUsCloseBtn {
    position: absolute;
    top: 15px;
    right: 20px;
}

.contactUsTitle {
    padding-top: 3%;
    text-align: center;
    font-size: 24pt;
}

.contactUsSubTitle {
    text-align: center;
    color: #959595;
    font-size: 20px;
    font-weight: 400;
}

.contactUsSubTitle_ {
    text-align: center;
    color: #959595;
    font-size: 20px;
    font-weight: 400;
}
.subjectInputWrapper {
    width: 70%;
    white-space: nowrap;
}

.subjectInputWrapper p {
    margin-bottom: 1% !important;
    font-size: 10pt;
    font-weight: 400;
    color: black;
}

.programInputWrapper {
    width: 100%;
}

.programInputWrapper p {
    margin-bottom: 1% !important;
    font-size: 10pt;
    font-weight: 400;
    color: black;
}

.titleInputWrapper {
    width: 50%;
}

.firstnameInputWrapper,
.lastnameInputWrapper {
    width: 80%;
}

.titleInputWrapper p,
.firstnameInputWrapper p,
.lastnameInputWrapper p {
    margin-bottom: 1% !important;
    font-size: 10pt;
    font-weight: 400;
    color: black;
}

.emailInputWrapper {
    width: 50%;
}

.emailInputWrapper p {
    margin-bottom: 1% !important;
    font-size: 10pt;
    font-weight: 400;
    color: black;
}

.messageInputWrapper {
    width: 100%;
}

.messageInputWrapper p {
    margin-bottom: 1% !important;
    font-size: 14pt;
    font-weight: 400;
    color: black;
}

.submitBtnWrapper {
    position: relative;
    text-align: center;
}

.submitBtnWrapper p {
    position: absolute;
    top: 50%;
    left: 0;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    font-size: 12px;
    color: black;
}

@media only screen and (max-width: 933px) {
    .contactUsCard,
    .contactUsCardResponse {
        background-image: linear-gradient(180deg, rgba(255, 255, 255, 0.8) 0%, rgba(255, 255, 255, 0.9) 100%),
            url("./contact_us.png");
    }

    .contactUsCardResponse {
        background-position: 100% 60%;
    }

    .contactUsTitle {
        padding-top: 10%;
        font-size: 20pt;
    }

    .contactUsSubTitle {
        font-size: 15px;
        padding: 5%;
    }

    .contactUsSubTitle_ {
        font-size: 15px;
    }

    .subjectInputWrapper {
        width: 100%;
    }

    .titleInputWrapper {
        width: 80%;
    }

    .submitBtnWrapper p {
        top: 115%;
    }

    .emailInputWrapper {
        width: 75%;
    }

    .subjectInput {
        max-width: 155px;
        text-overflow: ellipsis;
        overflow: hidden;
    }
}

@media only screen and (max-width: 425px) {
    .contactUsCard,
    .contactUsCardResponse {
        background-image: linear-gradient(180deg, rgba(255, 255, 255, 0.8) 0%, rgba(255, 255, 255, 0.9) 100%),
            url("./contact_us.png");
    }

    .contactUsCardResponse {
        background-position: 100% 60%;
    }

    .programInputWrapper {
        width: 65%;
        padding-left: 12px;
    }
}
</style>

<style lang="scss" scroped>
.contactUsInput .v-input__control .v-input__slot {
    min-height: auto !important;
}

.contactUsInput .v-input__control .v-select__slot {
    height: 33px;
}

.contactUsInput .v-input__control .v-select__slot .v-input__append-inner {
    margin-top: 4px !important;
}
</style>
